import { render, staticRenderFns } from "./SectionEmptyServices.vue?vue&type=template&id=5d831208&scoped=true"
import script from "./SectionEmptyServices.vue?vue&type=script&lang=js"
export * from "./SectionEmptyServices.vue?vue&type=script&lang=js"
import style0 from "./SectionEmptyServices.vue?vue&type=style&index=0&id=5d831208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d831208",
  null
  
)

export default component.exports